import React, { useEffect, useState } from "react";
import { 
  Box, Card, CardContent, CardMedia, Typography, Grid, CircularProgress,  
} from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Import Firebase config
import { useNavigate } from "react-router-dom";

const EventListRelated = () => {
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    privacy: [],
    eventType: [],
    price: [],
  });
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "events"));
        const eventList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setEvents(eventList);
        setFilteredEvents(eventList); // Initialize with all events
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchEvents();
  }, []);

  // Update filters dynamically
  useEffect(() => {
    let filtered = events.filter(event => {
      const matchesPrivacy = 
        filters.privacy.length === 0 || filters.privacy.includes(event.privacy);
      
      const matchesType = 
        filters.eventType.length === 0 || filters.eventType.includes(event.type);
      
      const matchesPrice = 
        filters.price.length === 0 || filters.price.includes(event.price);

      return matchesPrivacy && matchesType && matchesPrice;
    });

    setFilteredEvents(filtered);
  }, [filters, events]);

  // Handle filter changes
  const handleFilterChange = (category, value) => {
    setFilters(prevFilters => {
      const newValues = prevFilters[category].includes(value)
        ? prevFilters[category].filter(v => v !== value) // Remove if already selected
        : [...prevFilters[category], value]; // Add if not selected
      
      return { ...prevFilters, [category]: newValues };
    });
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />        
      </Box>      
    );
  }

  return (
    <Box sx={{p: 3, maxWidth: "1200px", margin: "auto", textAlign: "center", }}>     
     
      {/* Event List Section */}
      <Grid container spacing={2} >
                {filteredEvents.map(event => (
                  <Grid item key={event.id}  size={{ xs: 12, sm: 4, md: 3 }}  >
                    <Card sx={{ maxWidth: 345,  bgcolor:"grey.100"}} elevation={0} onClick={() => navigate(`/event/${event.id}`)} 
                      >
                      <CardMedia
                        sx={{ width: { xs: "100%", sm: "100%" }, height: 150 }}
                        image={event.eventImageURL || "https://placehold.co/150"} // Default image
                        alt={event.eventName}
                        title={event.eventName}
                      />
                      <CardContent>
                        <Typography gutterBottom variant="body2"  component="div">
                        {event.eventName}
                        </Typography>                 
                        <Typography variant="body2" color="inherit" mt={1}>
                          {/* 📅 { new Date(event.eventStartDate.seconds * 1000).toLocaleString()}  */}
                        </Typography>
                        <Typography variant="body2" color="inherit" mt={1}>
                        📍 {event.eventLocation}
                        </Typography>                        
                      </CardContent>                
                    </Card>                    
                  </Grid>
                ))}
              </Grid>   
    </Box>
  );
};

export default EventListRelated;
